import { CalculsFormCalendrierDeficitFonctionnelTemporaireTotal } from '@norma/shared/constants/calculs';
import { PrejudiceType } from '@norma/shared/types/prejudice.type';
import { Procedure } from '@norma/shared/types/procedure.type';
import { Victime } from '@norma/shared/types/victime.type';
import i18next from 'i18next';
import { dateString } from 'src/helpers/yup';
import * as yup from 'yup';
import {
  getDefaultMinAndMaxDate,
  validationSchemaNumeroPieces,
} from '../validation';

export const validationSchemaCalendrierDeficitFonctionnelTemporaireTotal = ({
  procedure,
  victime,
  prejudiceType,
}: {
  procedure: Procedure;
  victime: Victime;
  prejudiceType: PrejudiceType;
}): yup.ObjectSchema<CalculsFormCalendrierDeficitFonctionnelTemporaireTotal> => {
  const { minDate, maxDate } = getDefaultMinAndMaxDate({
    procedure,
    victime,
    prejudiceType,
  });
  return yup.object({
    forfaitJour: yup.number().nullable(),
    rows: yup.array().of(
      yup.object({
        dateDebut: dateString()
          .nullable()
          .required()
          .minDate(undefined, minDate.message, minDate.date)
          .maxDate(undefined, maxDate.message, maxDate.date),
        dateFin: dateString()
          .nullable()
          .required()
          .minDate(
            'dateDebut',
            i18next.t('validation.prejudices.dates.minDateDebut') || '',
          )
          .maxDate(undefined, maxDate.message, maxDate.date),
        forfaitJour: yup.number().required(),
        totalJours: yup.number().required().min(0),
        montantTotal: yup.number().required().min(0),
        commentaires: yup.string(),

        numerosPieces: validationSchemaNumeroPieces,
        motifHospitalisation: yup.string().defined().nullable(),
      }),
    ),
  });
};
